export default __webpack_public_path__ + "static/media/16CasinoBingoBrands.53943b87.svg";